import http from '@/utils/axios'
import type {
	MarketingBrandResponse,
	MarketingBrand,
} from '@/_new-code/models/consumer-engagement-models'
import type {Result} from '@/_new-code/utilities/types'

export const fetchMarketingBrands = async (
	locale: string
): Promise<MarketingBrand[]> => {
	const endpoint = `/api/species/all/marketingbrands?locale=${locale}`
	const {data: response} =
		await http<Result<MarketingBrandResponse>>(endpoint)

	if (!response.success) {
		throw new Error('Failed to create pet profile')
	}

	return response.data.data
}
